import { inject, provideAppInitializer, DOCUMENT } from '@angular/core'

import { environment } from '@env'

export const recaptchaInitializer = provideAppInitializer(() => {
	const document = inject(DOCUMENT)
	const script = document.createElement('script')

	script.src = `https://www.google.com/recaptcha/api.js?render=${environment.reCaptcha.siteKey}`
	script.async = true
	script.defer = true
	document.body.appendChild(script)
})
